module.exports = __webpack_public_path__ + "img/forward.f614357d.svg";